import { Directive, ElementRef, EventEmitter, Output, HostListener } from '@angular/core';

import { RangeValue } from '@ionic/core';
import { IonRange } from '@ionic/angular';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'ion-range'
})
export class RangeEventsDirective {
  @Output() public ionStart: EventEmitter<RangeValue> = new EventEmitter();
  @Output() public ionEnd: EventEmitter<RangeValue> = new EventEmitter();

  public constructor(protected elemRef: ElementRef<IonRange>) {}

  @HostListener('mousedown', ['$event'])
  @HostListener('touchstart', ['$event'])
  public onStart(ev: Event): void {
    this.ionStart.emit(this.elemRef.nativeElement.value);
    ev.preventDefault();
  }

  @HostListener('mouseup', ['$event'])
  @HostListener('touchend', ['$event'])
  public onEnd(ev: Event): void {
    this.ionEnd.emit(this.elemRef.nativeElement.value);
    ev.preventDefault();
  }

}
